import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { withStyles } from 'tss-react/mui';
import Container from '@mui/material/Container';
import CircleProgressButton from '../../buttons/CircleProgressButton';
import AuthDialogConstants from './AuthDialogConstants';
import { validateEmail } from '../../../utilities/authUtilities';

const styles = theme => ({
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 3),
    },
    toggleButton: {
        textTransform: 'none',
        marginBottom: theme.spacing(1)
    }
});

class PasswordRecoverForm extends React.Component {
    state = {
        email: '',
        shouldValidate: false,
        emailError: false,
    }

    render() {
        const { classes, setFormType, requesting } = this.props;
        const { email, emailError } = this.state;

        return (
            <Container maxWidth='xs'>
                <div className={classes.paper}>
                    <Typography variant='h5' id='auth-dialog-label'>
                        Recover password
                    </Typography>
                    <form className={classes.form} noValidate>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12 }}>
                                <TextField
                                    variant='standard'
                                    required
                                    fullWidth
                                    label='Email Address'
                                    autoComplete='email'
                                    value={email}
                                    onChange={this.setEmail}
                                    error={emailError}
                                    onKeyDown={(e) => {
                                        if (e.keyCode === 13) {
                                            this.resetClick()
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }} hidden>
                                <TextField variant="standard" />
                            </Grid>
                        </Grid>
                        <CircleProgressButton
                            fullWidth
                            variant='contained'
                            color='primary'
                            className={classes.submit}
                            onClick={this.resetClick}
                            loading={requesting}
                        >
                            Send reset link
                        </CircleProgressButton>
                        <Grid container justifyContent='center'>
                            <Grid>
                                <Button
                                    variant='text'
                                    size='small'
                                    onClick={() => setFormType(AuthDialogConstants.FORM_TYPE_LOGIN)}
                                    className={classes.toggleButton}>
                                    Log in
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent='center'>
                            <Grid>
                                <Button
                                    variant='text'
                                    size='small'
                                    onClick={() => setFormType(AuthDialogConstants.FORM_TYPE_SIGN_UP)}
                                    className={classes.toggleButton}>
                                    Create new account
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Container>
        );
    }

    resetClick = () => {
        const { recoverPassword } = this.props;
        const { email } = this.state;

        this.setState({ shouldValidate: true });
        var valid = this.validate(this.state.email);
        if (valid) {
            recoverPassword(email);
        }
    }

    setEmail = (event) => {
        this.setState({ email: event.target.value })
        if (this.state.shouldValidate) {
            this.validate(event.target.value);
        }
    }

    validate = (email) => {
        var valid = true;

        if (email.length < 1 || !validateEmail(email)) {
            this.setState({ emailError: true })
            valid = false;
        } 
        else {
            this.setState({ emailError: false })
        }

        return valid;
    }
}

export default withStyles(PasswordRecoverForm, styles);